import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

export type FilterGroup = {
  g?: RanksackGroup[]
  m: string
}

export type RanksackGroup = Record<string, string | string[]>[]

export type RansackFilter = RanksackGroup | FilterGroup[]

export function applyFilters(usersFilter?: IFilterData) {
  if (usersFilter) {
    const { generalCondition = 'and' } = usersFilter
    if (usersFilter.filterType === 'simple') {
      const g: RanksackGroup = [
        {
          m: generalCondition || 'and',
        },
      ]
      const toDelete = [] as string[]
      usersFilter.data?.map(
        ({ input, operator, compareTo, condition = generalCondition }) => {
          if (!compareTo) return
          if (g[0][`${input}_${operator}`] && !operator?.includes('null')) {
            const op =
              condition === 'and' ? `${operator}_all` : `${operator}_any`
            toDelete.push(`${input}_${operator}`)
            const value = g[0][`${input}_${op}`]
            if (Array.isArray(value)) {
              value.push(compareTo)
            } else {
              g[0][`${input}_${op}`] = [
                g[0][`${input}_${operator}`],
                compareTo,
              ] as string[]
            }
          } else {
            g[0][`${input}_${operator}`] = compareTo
          }
        }
      )
      if (toDelete.length)
        toDelete.map((row: string) => {
          delete g[0][row]
        })
      return g
    } else {
      const g: FilterGroup[] = [{ m: generalCondition }]
      const gLocal: FilterGroup[] = (g[0]['g'] = [])

      usersFilter.groupedData?.map(({ data, groupCondition, group }) => {
        gLocal.push({ m: '' })
        gLocal[group]['m'] = groupCondition
        const toDelete: string[] = []
        data?.map(({ input, operator, compareTo }: any) => {
          if (gLocal[group][`${input}_${operator}`]) {
            const op =
              groupCondition === 'and' ? `${operator}_all` : `${operator}_any`
            toDelete.push(`${input}_${operator}`)
            if (Array.isArray(gLocal[group][`${input}_${op}`])) {
              gLocal[group][`${input}_${op}`].push(compareTo)
            } else {
              gLocal[group][`${input}_${op}`] = [
                gLocal[group][`${input}_${operator}`],
                compareTo,
              ]
            }
          } else {
            gLocal[group][`${input}_${operator}`] = compareTo
          }
        })
        if (toDelete.length)
          toDelete.map((row: string) => {
            delete gLocal[group][row]
          })
      })
      return g
    }
  }
  return []
}
